// Schemas
import { tierOfferListSchema, creditPackOfferListSchema, subscriptionSchema } from 'modules/subscription/models'

// Types
import { APIAction } from 'types'

export const actions = {
  startTrial: (offerId: number, periodId: number): APIAction => ({
    CALL_API: {
      type: 'START_TRIAL',
      method: 'POST',
      endpoint: '/api/subscriptions/subscription/start_trial/',
      schema: subscriptionSchema,
      data: {
        offer_id: offerId,
        period_id: periodId,
      },
    },
  }),

  fetchTierOffers: (code?: string): APIAction => ({
    CALL_API: {
      type: 'FETCH_TIER_OFFERS',
      method: 'GET',
      endpoint: `/api/subscriptions/offer/${code ? `?code=${code}` : ''}`,
      schema: tierOfferListSchema,
      requestKey: code,
      actionParams: {
        code,
      },
    },
  }),

  changeNextPeriod: (periodId: number): APIAction => ({
    CALL_API: {
      type: 'CHANGE_NEXT_PERIOD',
      method: 'POST',
      endpoint: '/api/subscriptions/subscription/change_next_period/',
      schema: subscriptionSchema,
      data: {
        period_id: periodId,
      },
    },
  }),

  fetchCreditPackOffers: (): APIAction => ({
    CALL_API: {
      type: 'FETCH_CREDIT_PACK_OFFERS',
      method: 'GET',
      endpoint: '/api/subscriptions/creditpackoffer/',
      schema: creditPackOfferListSchema,
    },
  }),

  cancelSubscription: (cancelReason: Record<string, unknown>): APIAction => ({
    CALL_API: {
      type: 'CANCEL_SUBSCRIPTION',
      method: 'POST',
      endpoint: '/api/subscriptions/subscription/cancel/',
      schema: subscriptionSchema,
      data: cancelReason,
    },
  }),

  resubscribe: (): APIAction => ({
    CALL_API: {
      type: 'RESUBSCRIBE',
      method: 'POST',
      endpoint: '/api/subscriptions/subscription/renew/',
      schema: subscriptionSchema,
    },
  }),
}
